import { FieldSearchBar, FieldSearchBarProps } from '@cibo/landmanager'
import { usePrograms } from '../../queries'

export const FieldSearchBarWithPrograms = (props: FieldSearchBarProps) => {
  const programs = usePrograms({
    sort: [
      { sort: 'desc', field: 'enrollmentStatus' },
      { sort: 'desc', field: 'closeDate' },
    ],
  })

  return <FieldSearchBar programs={programs.data} {...props} />
}
